import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type NamedEntity } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useCreateNamedEntity } from "../../hooks/named-entities"
import { initialValuesNamedEntity, validationSchemaNamedEntity } from "./NamedEntityCommon"
import NamedEntityForm from "./NamedEntityForm"

export default function NamedEntityCreate() {
  const createNamedEntity = useCreateNamedEntity()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesNamedEntity(), [])
  const validationSchema = useMemo(() => validationSchemaNamedEntity(), [])

  useBreadcrumbs([{ label: "Entità", href: "/named-entities/named-entities" }, { label: "Creazione Entità" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova entità</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createNamedEntity.mutateAsync(values as NamedEntity).then((namedEntity) => {
                navigate(`/named-entities/named-entities/${namedEntity.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <NamedEntityForm />
                </Container>
                <BottomFormFixed url="/named-entities/named-entities" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
